import React from 'react';

const DEFAULT_FILL = '#555';

export const NavIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="23" height="19" viewBox="0 0 23 19">
    <rect y="16" width="23" height="3" rx="1.5" fill={DEFAULT_FILL} />
    <rect width="23" height="3" rx="1.5" fill={DEFAULT_FILL} />
    <rect y="8" width="23" height="3" rx="1.5" fill={DEFAULT_FILL} />
  </svg>
);
